import React from "react";
import { Box, Checkbox, Link, Typography } from "@mui/material";
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { getPrivacyPolicyUrl, getTermsConditionsUrl } from "src/utils/legalPageUrls";

const termsConditionsUrl = getTermsConditionsUrl();
const privacyPolicyUrl = getPrivacyPolicyUrl();

interface CheckTermsAndConditionProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
}

const CheckTermsAndCondition: React.FC<CheckTermsAndConditionProps> = ({
    checked,
    onChange,
}) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            sx={{ pt: 1, pb: 0 }}
        >
            <Checkbox
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                sx={{
                    padding: 0,
                    pt: 0,
                    marginRight: 1,
                    color: "#ff672d",
                    "&.Mui-checked": {
                        color: "#ff672d",
                    },
                    "&:hover": {
                        backgroundColor: "transparent",
                    },
                }}
            />

            <Typography
                variant="h6"
                sx={{ color: "#ffffff", fontSize: "14px", lineHeight: 1.4 }}
            >
                I have read and agreed with the{' '}
                <Link
                    href={termsConditionsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={async (e) => {
                        if (Capacitor.isNativePlatform()) {
                            e.preventDefault();
                            await Browser.open({ url: termsConditionsUrl });
                        }
                    }}
                    style={{ color: "#1976d2", textDecoration: "underline", }}
                >
                    Terms and Conditions
                </Link> {' '} and{' '}<Link
                    href={privacyPolicyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={async (e) => {
                        if (Capacitor.isNativePlatform()) {
                            e.preventDefault();
                            await Browser.open({ url: privacyPolicyUrl });
                        }
                    }}
                    style={{ color: "#1976d2", textDecoration: "underline" }}
                >
                    Privacy Policy
                </Link>.
            </Typography>
        </Box>
    );
};

export default CheckTermsAndCondition;
